import Image from 'next/image';
import Link from 'next/link';
import { HiArrowCircleRight } from 'react-icons/hi';

import useProfile from '@/modules/core/hooks/useProfileHook';
import Button, { ButtonIconPosition } from '@/tayara-kit/Button';
import Divider, { Orientation } from '@/tayara-kit/Divider';
import Text from '@/tayara-kit/Text';

const LoginFinish = () => {
  const { userData } = useProfile();

  return (
    <div className="max-w-screen w-screen lg:w-[99999px] lg:max-w-xl bg-base-100 lg:border border-gray-200 p-6 lg:p-8 lg:rounded-lg relative lg:h-17">
      <div className="flex justify-center">
        <Image
          width={176}
          height={157}
          src="/media/t-celebrate.svg"
          alt="tayara celebration illustration"
          className="w-40"
        />
      </div>
      <div className="flex flex-col items-center justify-center mt-10 gap-y-2">
        <Text text={`Bienvenue ${userData?.fullname}!`} as="h2" />
        <Divider orientation={Orientation.HORIZONTAL} />
        <Link href={'/profile'} replace passHref className="w-full">
          <Button
            aria-label="Profil"
            icon={<HiArrowCircleRight size={20} />}
            iconPosition={ButtonIconPosition.End}
            className="w-full"
          >
            Voir mon profil
          </Button>
        </Link>
        <Link href={'/post-listing'} replace passHref className="w-full">
          <Button
            aria-label="Créer annonce"
            icon={<HiArrowCircleRight size={20} />}
            iconPosition={ButtonIconPosition.End}
            className="w-full"
          >
            Créer une annonce
          </Button>
        </Link>
        <Link
          href={'/profile/?t=myListings'}
          replace
          passHref
          className="w-full"
        >
          <Button
            aria-label="Acceuil"
            icon={<HiArrowCircleRight size={20} />}
            iconPosition={ButtonIconPosition.End}
            className="w-full"
          >
            Voir toutes les annonces
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default LoginFinish;
